<div class="panel-group" id="accordion">
  <app-report-detail-section [section]="'questionsList'" [title]="'Questions / answers'"
  [allExpandState]="allExpandState"></app-report-detail-section>
  <div #section id="questionsList" class="panel-collapse collapse">
    <div class="panel-body">
      <app-question-list [questionsAndAnswers]="questionAndAnswers"></app-question-list>
      @if (!(questionAndAnswers.length > 0)) {
        <label> No Questions / Answers</label>
      }
      <!-- Involvements -->
      @if (involvementDetails && involvementDetails.length > 0) {
        <h3 class="involvement-header">People
        Involved</h3>
      }
      @for (reportInvolvement of involvementDetails; track reportInvolvement) {
        <div class="question-container">
          @if (reportInvolvement.validateRules | hideFromReportDetailPipe) {
            <app-person-details [involvement]="reportInvolvement"></app-person-details>
          }
        </div>
      }
    </div>
  </div>
</div>
